// Resolve a possibly-relative media URL against the backend origin so that
// <img> tags render correctly in every environment (preview + production).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function resolveMediaUrl(url) {
  if (!url) return "";
  if (/^(https?:)?\/\//i.test(url) || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
